import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  link: {
    color: theme.palette.secondary.dark,
    marginLeft: 8,
    textDecoration: "underline",
    whiteSpace: "nowrap",
    "&:hover": {
      textDecoration: "underline",
      cursor: "pointer"
    }
  }
}));
